import { LegalProceedingFilter } from '../../../../../shared/types/legalProceedings/legalProceedings';

export const initialValues: LegalProceedingFilter = {
    startDate: undefined,
    endDate: undefined,
    nameClaimant: '',
    documentClaimant: '',
    status: '',
    fileNumber: '',
};
